import { apiCallStatus } from 'helpers/constants';
import { filterActionTypes } from './constants';
import { updateCurrentFleetsOnFilterChange } from './helpers';

const initialState = {
    fleetsFilter: {
        customers: [],
        search: '',
        showMyFleets: false,
    },
    multiLevelFilter: {
        organizationId: null,
        countryCode: null,
        siteId: null,
        owner: null,
    },
    assetGroups: {
        data: [],
        currentData: [],
        isLoading: apiCallStatus.LOADING
    },
    fleetLoading: {},
    selectedfleet: null,
    initialLoad: false,
    dashboardRefreshAnalytics: false,
    dashboardRefreshOrigin: null,
    lastUpdatedTimestamp: null,
};

const mergeFleetData = (state, action, dataType = 'currentData') => {
    const assetGroupId = action?.data?.assetGroupId;
    if (assetGroupId && assetGroupId?.length > 0) {
        const updatedAssetGroups = state?.assetGroups?.[dataType]?.map((group) => {
            if (group?.id === assetGroupId[0]) {
                return { ...group, assetDataForCharts: { ...action?.data } };
            } else {
                return group;
            }
        });
        return updatedAssetGroups;
    } else {
        return state?.assetGroups?.[dataType];
    }
};

const setFleetLoadingStatus = (state, action) => {
    const loadingStatus = state.fleetLoading;
    return { ...loadingStatus, ...action?.data };
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case filterActionTypes.SET_FLEET_FILTERS:
            return {
                ...state,
                fleetsFilter: {
                    ...state.fleetsFilter,
                    ...action.data
                },
                initialLoad: action.initialLoad || false
            };
        case filterActionTypes.SET_FLEET_MULTI_LEVEL_FILTERS: {
            const isClearFilters = action.data?.clearFilters === true;
            const updatedCurrentFleets = updateCurrentFleetsOnFilterChange({
                ...initialState.multiLevelFilter,
                ...action.data
            }, state);
            return {
                ...state,
                multiLevelFilter: isClearFilters ?
                    { ...initialState.multiLevelFilter, ...action.data }
                    : { ...state.multiLevelFilter, ...action.data },
                assetGroups: {
                    ...state.assetGroups,
                    currentData: updatedCurrentFleets
                },
                initialLoad: action.initialLoad || state.initialLoad
            };
        }
        case filterActionTypes.GET_FLEET_ASSET_GROUP: {
            const updatedCurrentFleets = updateCurrentFleetsOnFilterChange({
                ...state.multiLevelFilter
            }, { assetGroups: { ...state.assetGroups, data: action.data, currentData: action.data } });
            return {
                ...state,
                assetGroups: {
                    data: action.data,
                    currentData: updatedCurrentFleets,
                    isLoading: action.loadingStatus,
                },
                initialLoad: true
            };
        }
        case filterActionTypes.GET_FLEET_DATA: {
            const mergedData = mergeFleetData(state, action, 'data');
            const mergedCurrentData = mergeFleetData(state, action, 'currentData');
            return {
                ...state,
                assetGroups: {
                    data: mergedData,
                    currentData: mergedCurrentData,
                    isLoading: action.loadingStatus
                },
            };
        }
        case filterActionTypes.SET_FLEET_LOADING:
            return {
                ...state,
                fleetLoading: setFleetLoadingStatus(state, action)
            };
        case filterActionTypes.SET_SELECTED_FLEET:
            return {
                ...state,
                selectedfleet: action.data
            };
        case filterActionTypes.SET_INITIAL_LOAD_DASHBOARD:
            return {
                ...state,
                initialLoad: action.data
            };
        case filterActionTypes.SET_DASHBOARD_REFRESH_ANALYTICS:
            return {
                ...state,
                dashboardRefreshAnalytics: action?.data === true
            };

        case filterActionTypes.SET_DASHBOARD_REFRESH_ORIGIN:
            return {
                ...state,
                dashboardRefreshOrigin: action?.data,
            };

        case filterActionTypes.REFRESH_FLEET_CONDITION: {
            // Clear any existing chart data for all asset groups so charts will refresh
            const clearedData = state.assetGroups?.currentData?.map(g => ({ ...g, assetDataForCharts: null })) ?? [];
            return {
                ...state,
                assetGroups: {
                    ...state.assetGroups,
                    data: clearedData,
                    currentData: clearedData,
                },
                fleetLoading: initialState.fleetLoading, // Reset fleetLoading to an empty object
            };
        }

        case filterActionTypes.REFRESH_FLEET_ALL: {
            return {
                ...state,
                fleetsFilter: {
                    ...initialState.fleetsFilter,
                    showMyFleets: state.fleetsFilter.showMyFleets // Preserve showMyFleets value
                }, // Reset fleetsFilter to initial state
                multiLevelFilter: initialState.multiLevelFilter, // Reset multiLevelFilter to initial state
                assetGroups: initialState.assetGroups, // Reset assetGroups to initial state
                fleetLoading: initialState.fleetLoading, // Reset fleetLoading to an empty object
                initialLoad: false,
            };
        }

        case filterActionTypes.SET_LAST_UPDATED_TIMESTAMP:
            return {
                ...state,
                lastUpdatedTimestamp: action?.data,
            };

        default:
            return state;
    }
};

export default reducer;
